module.exports = __webpack_public_path__ + "img/art-5.0d05d441.png";